import type { RecordOrder } from '@/types/clinician';

const PHARMACY_NAMES: Record<string, string> = {
  precisionmeds: 'Precision Meds',
  the_pharmacy_hub: 'The Pharmacy Hub',
  optiorx: 'OptioRx',
};

export function OrderPharmacyLabel({ order }: { order: RecordOrder }) {
  const key = order.pharmacy_partner_key?.trim().toLowerCase();
  const label =
    !key || key === 'unknown' || key === 'careportals'
      ? 'Pharmacy not recorded'
      : key === 'unrouted'
        ? 'Pharmacy not yet assigned'
        : `Pharmacy: ${PHARMACY_NAMES[key] ?? order.pharmacy_partner_key?.trim()}`;

  return (
    <span
      className="break-words"
      title={
        order.medication ? `${label}\nMedication: ${order.medication}` : label
      }
    >
      {label}
      {order.medication ? ' ⓘ' : ''}
    </span>
  );
}
